var symphony = symphony || {};

;
symphony.phoneNumberConverter = {

    init: function () {

        var isNumericInput = function (event) {
            var key = event.keyCode;
            return ((key >= 48 && key <= 57) || // Allow number line
                (key >= 96 && key <= 105) // Allow number pad
            );
        };

        var isModifierKey = function (event) {
            var key = event.keyCode;
            return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
                (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
                (key > 36 && key < 41) || // Allow left, up, right, down
                (
                    // Allow Ctrl/Command + A,C,V,X,Z
                    (event.ctrlKey === true || event.metaKey === true) &&
                    (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
                )
        };

        var enforceFormat = function (event) {
            // Input must be of a valid number format or a modifier key, and not longer than ten digits
            if (!isNumericInput(event) && !isModifierKey(event)) {
                event.preventDefault();
            }
        };

        var formatToPhone = function (event) {
            if (isModifierKey(event)) {
                return;
            }

            var input = event.target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
            var areaCode = input.substring(0, 3);
            var middle = input.substring(3, 6);
            var last = input.substring(6, 10);

            if (input.length > 6) {
                event.target.value = areaCode + "-" + middle + "-" + last;
            } else if (input.length > 3) {
                event.target.value = areaCode + "-" + middle;
            } else if (input.length > 0) {
                event.target.value = areaCode;
            }
        };

        var inputElements = document.getElementsByClassName('phoneconvert');

        if (inputElements.length > 0 && siteCountry == 'US') {
            for (var i = 0; i < inputElements.length; i++) {
                if (inputElements[i] != undefined && inputElements[i] != null) {
                    inputElements[i].setAttribute('maxlength', 12)
                    inputElements[i].addEventListener('keydown', enforceFormat);
                    inputElements[i].addEventListener('keyup', formatToPhone);
                }
            }
        }

    },

};
